module.exports = __webpack_public_path__ + "img/17-AROCARIA-min.d8b92ccf.jpg";